import {
  cubicBezier,
  type Transition,
  type Variant,
  type Variants,
} from 'framer-motion';

// transitions
const endAnimationTransition: Transition = {
  duration: 0.3,
  ease: cubicBezier(0, 0, 0.58, 1),
};

const startAnimationTransition: Transition = {
  delay: 1.5,
  duration: 0.5,
  ease: cubicBezier(0, 1, 1, 1),
};

//buttons animation variants
const startButtonTransition: Variant = {
  x: 0,
  y: 0,
  transition: startAnimationTransition,
};

const topButtonAnimationVariants: Variants = {
  start: startButtonTransition,
  end: {
    x: '-50%',
    y: 'calc(50% + 4px)',
    transition: endAnimationTransition,
  },
};

const bottomButtonAnimationVariants: Variants = {
  start: startButtonTransition,
  end: {
    x: '50%',
    y: 'calc(-50% - 4px)',
    transition: endAnimationTransition,
  },
};

//block animation variants

const startBlockVariant: Variant = {
  y: 0,
  transition: startAnimationTransition,
};

const topBlockAnimationVariants: Variants = {
  start: startBlockVariant,
  end: {
    y: -50,
    transition: endAnimationTransition,
  },
};

const bottomBlockAnimationVariants: Variants = {
  start: startBlockVariant,
  end: {
    y: 50,
    transition: endAnimationTransition,
  },
};

export {
  bottomBlockAnimationVariants,
  bottomButtonAnimationVariants,
  topBlockAnimationVariants,
  topButtonAnimationVariants,
};
